var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.variant === 'tertiary')?_c('button',_vm._g({class:`button-${_vm.variant}`},_vm.$listeners),[(_vm.icon)?_c('NbIcon',{class:_vm.$slots.default ? 'mr-2' : '',attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2):(_vm.icon)?_c('button',_vm._g({staticClass:"button-icon",class:` nb-button button-${_vm.variant} ${_vm.size}`},_vm.$listeners),[_c('NbIcon',{staticClass:"mr-2",attrs:{"icon":_vm.icon,"attributes":{
      class: 'mb-1',
      'stroke-width': 3,
      width: '1rem',
      height: '1rem',
    }}}),_vm._t("default")],2):_c('button',_vm._g({class:` nb-button button-${_vm.variant} ${_vm.size}`},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }